import script from "./security-event-distribution-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-event-distribution-chart.vue?vue&type=script&setup=true&lang=ts"

import "./security-event-distribution-chart.vue?vue&type=style&index=0&id=17aaaa50&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17aaaa50"]])

export default __exports__